import {BASEURL} from "../config/AppUrl";

export default {
    // Cache-busted so the refreshed IMS mark replaces the old one immediately.
    logo: BASEURL+'/images/logo.png?v=2',
    logoIcon: BASEURL+'/images/logo_icon.png?v=2',
    logoEnetIcon: BASEURL+'/images/logo_enet_icon.png',
    spinner: BASEURL+'/images/spinner.gif',
    excelIcon: BASEURL+'/images/xls.png',
    pdfIcon: BASEURL+'/images/pdf.png',
    photoMenu: BASEURL+'/images/menu_photo.jpg',
};
